/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeDRadiusUpRightIcon24Solid = forwardRef('ArrowShapeDRadiusUpRightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 3.448c0-1.202 1.455-1.805 2.306-.954l8.178 8.18c.732.731.732 1.918 0 2.65l-8.178 8.18c-.85.85-2.305.248-2.305-.955V17c-1.8 0-3.18.008-4.564.454-1.37.441-2.807 1.336-4.608 3.24-.604.638-1.777.306-1.814-.673-.168-4.415 1.09-7.691 3.219-9.865C6.298 8.047 9.106 7.055 12 7.002V3.448Z" })));
});
